import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { ErrorHandlerService } from "../services/error-handler.service";
import { TabSessionService } from "../services/tab-session.service";

@Component({
    selector: "app-error-handler",
    templateUrl: "./error-handler.component.html",
    styleUrls: ["./error-handler.component.css"],
    standalone: false
})
export class ErrorHandlerComponent implements OnInit {
  private route = inject(ActivatedRoute);
  errorService = inject(ErrorHandlerService);
  private tabSessionService = inject(TabSessionService);

  errorId!: number;
  errorMessage!: string;
  skinPath = environment.assets;
  ngOnInit(): void {
    const body = document.getElementsByTagName("body")[0];
    body.className = "";
    body.classList.add("error");

    this.errorId = +this.route.snapshot.paramMap.get("id")!;
    this.errorMessage = this.errorService.lookupErrorMessageForID(this.errorId);
  }

  logout(): void {
    void this.tabSessionService.logout();
  }
}
